module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-41.481cb6af.png";